import {Board} from '../board';
import {PlacedBin} from '../placed-bin';

export class ScoreCalculator {

    constructor(
        public board: Board,
        public placedBins: PlacedBin[]
    ) {}

    public calc(placedBin: PlacedBin): number {
        // To be implemented.

        return 0;
    }

}
